import axiosInstance from "../lib/axios";
import type { AuthUser } from "../lib/authStorage";

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  message: string;
  data: {
    token: string;
    user: AuthUser;
  };
}

export const login = async (payload: LoginRequest) => {
  const { data } = await axiosInstance.post<LoginResponse>("/auth/login", payload);
  return data;
};

// Re-export supaya komponen cukup import dari satu tempat ("../api/authApi")
export {
  saveAuthSession,
  getAuthToken,
  getAuthUser,
  clearAuthSession,
  isAuthenticated,
  type AuthUser,
} from "../lib/authStorage";